<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="900px">
    <template v-slot:title>Update Pax</template>
    <v-container v-if="accommodationSettings.length > 0">
      <h6 class="subtitle-2">ACCOMMODATION:</h6>
      <v-row v-for="roomType in accommodationSettings" :key="roomType.id">
        <v-col cols="6">
          <v-text-field
            type="number"
            :label="roomType.label"
            v-model.number="roomType.qty"
            :min="roomType.min"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-col>
        <v-col xs2>
          <v-text-field
            type="number"
            label="Adults"
            v-model.number="roomType.adults"
            @change="onPaxChange(roomType)"
            min="0"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-col>
        <v-col xs2>
          <v-text-field
            type="number"
            label="Children"
            v-model.number="roomType.children"
            @change="onPaxChange(roomType)"
            min="0"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-col>
        <v-col xs2>
          <v-text-field
            type="number"
            label="Infants"
            v-model.number="roomType.infants"
            @change="onPaxChange(roomType)"
            min="0"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" class="text-right py-0">
          <h3>Total:</h3>
        </v-col>
        <v-col class="py-0">{{ totals.adults }}</v-col>
        <v-col class="py-0">{{ totals.children }}</v-col>
        <v-col class="py-0">{{ totals.infants }}</v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-container v-for="otherType in otherTypesSettings" :key="otherType.id">
      <h6 class="subtitle-2">{{ otherType.label }}:</h6>
      <v-row>
        <v-col>
          <v-text-field
            type="number"
            label="Adults"
            v-model.number="otherType.adults"
            min="0"
            :outlined="outlinedInputs"
            hide-details
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            type="number"
            label="Children"
            v-model.number="otherType.children"
            min="0"
            :outlined="outlinedInputs"
            hide-details
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            type="number"
            label="Infants"
            v-model.number="otherType.infants"
            min="0"
            :outlined="outlinedInputs"
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
    <template v-slot:actions>
      <v-btn color="primary" @click="onUpdate">Update</v-btn>
    </template>
    <v-row v-if="debug">
      <v-col>
        <code>{{ roomTypes }}</code>
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
var randomize = require("randomatic");
export default {
  name: "service-type-pax-updater",

  props: {
    headerProps: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  components: { BasicDialog },

  data() {
    return {
      debug: false,
      roomTypes: this.value ? [...this.getRoomTypes()] : [],
      maxAdults:
        this.headerProps && this.headerProps.adults
          ? this.headerProps.adults
          : 2,
      maxInfants:
        this.headerProps && this.headerProps.infants
          ? this.headerProps.infants
          : 0,
      maxChildren:
        this.headerProps && this.headerProps.children
          ? this.headerProps.children
          : 0,
      otherTypes: [
        {
          id: randomize("Aa0", 32),
          label: "TRANSPORT",
          adults: 0,
          children: 0,
          infants: 0,
          type: "TRANSPORT",
        },
        {
          id: randomize("Aa0", 32),
          label: "ACTIVITY",
          adults: 0,
          children: 0,
          infants: 0,
          type: "ACTIVITY",
        },
        {
          id: randomize("Aa0", 32),
          label: "TRAVEL",
          adults: 0,
          children: 0,
          infants: 0,
          type: "TRAVEL",
        },
        {
          id: randomize("Aa0", 32),
          label: "OTHER",
          adults: 0,
          children: 0,
          infants: 0,
          type: "OTHER",
        },
        {
          id: randomize("Aa0", 32),
          label: "MANDATORY_CHARGES",
          adults: 0,
          children: 0,
          infants: 0,
          type: "MANDATORY_CHARGES",
        },
      ],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    accommodationSettings() {
      const accommodationServices = this.value
        .filter((item) => item.serviceTypeName == "ACCOMMODATION")
        .map((item) => item.service.typeName);
      //console.log("accommodationServices", accommodationServices);
      return [
        ...this.roomTypes.filter(
          (rt) => accommodationServices.indexOf(rt.type) > -1
        ),
      ];
    },
    otherTypesSettings() {
      const otherServicesTypes = [
        ...new Set(
          this.value
            .filter((item) => item.serviceTypeName != "ACCOMMODATION")
            .map((item) => item.serviceTypeName)
        ),
      ];
      return this.otherTypes.filter(
        (ot) => otherServicesTypes.indexOf(ot.type) > -1
      );
    },
    totals() {
      const totals = this.roomTypes.reduce(
        (t, roomType) => {
          t.adults = Number(t.adults) + Number(roomType.adults);
          t.children = Number(t.children) + Number(roomType.children);
          t.infants = Number(t.infants) + Number(roomType.infants);
          return t;
        },
        { adults: 0, children: 0, infants: 0 }
      );
      return totals;
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.roomTypes = [...this.getRoomTypes()];
      }
    },
  },

  methods: {
    onPaxChange(roomType) {
      if (this.adults > this.maxAdults) this.adults = this.maxAdults;
      if (this.children > this.maxChildren) this.children = this.maxChildren;
      if (this.infants > this.maxInfants) this.infants = this.maxInfants;
      const pax = Number(roomType.adults) + Number(roomType.children);
      roomType.qty = Math.ceil(pax / roomType.occupancy);
      roomType.min = Math.ceil(pax / roomType.occupancy);
      for (const ots of this.otherTypesSettings) {
        ots.adults = this.totals.adults;
        ots.children = this.totals.children;
        ots.infants = this.totals.infants;
      }
    },
    onUpdate() {
      this.$emit("update", {
        accommodationSettings: this.accommodationSettings,
        otherTypesSettings: this.otherTypesSettings,
        totals: { ...this.totals },
      });
    },
    getRoomTypes() {
      const rt = [];
      if (this.value.length > 0) {
        for (const item of this.value) {
          if (
            item.service &&
            rt.map((i) => i.type).indexOf(item.service.typeName) == -1
          ) {
            rt.push({
              id: randomize("Aa0", 32),
              adults: 0,
              children: 0,
              infants: 0,
              label: item.service.typeName,
              type: item.service.typeName,
              occupancy: item.service.stdOccupancy,
              qty: 0,
            });
          }
        }
      }
      return rt;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/scenarios/ServiceTypePaxUpdater.vue